import React from "react"
import PropTypes from "prop-types"

const Mepha = ({ fillColor }) => (
  <svg
    width="143"
    height="39"
    viewBox="0 0 143 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5115 15.4056C14.7557 14.032 13.3066 13.3323 11.195 13.3323C8.79718 13.3323 7.0534 14.2749 6.23399 15.1193C6.23399 14.9105 6.23399 13.6444 6.23399 13.6444H1.96094V25.274H6.37179V19.115C6.37179 17.2546 7.90462 16.5921 9.3378 16.5921C10.0279 16.5921 11.6307 16.7709 11.6307 18.4215V25.274H16.0415V19.114C16.0415 17.2546 17.551 16.5921 18.962 16.5921C19.8354 16.5921 21.3015 16.8309 21.3015 18.4215V25.274H25.7124V17.5378C25.7124 13.7436 22.1442 13.3323 20.6093 13.3323C18.4786 13.3323 16.72 14.0516 15.5115 15.4056Z"
      fill="#1B1C20"
    />
    <path
      d="M68.0189 9.81506H63.6589V25.274H68.0709V19.7837C68.0709 17.0076 70.1581 16.5921 71.4026 16.5921C73.1294 16.5921 73.97 17.3177 73.97 18.8111V25.274H78.382V17.666C78.382 13.6454 74.1757 13.3323 72.8867 13.3323C70.6266 13.3323 68.8436 14.2232 68.0709 15.0852C68.0709 14.8381 68.0709 9.81506 68.0709 9.81506H68.0189Z"
      fill="#1B1C20"
    />
    <path
      d="M54.375 13.3291C52.7161 13.3291 51.373 13.6226 49.8518 15.0303C49.8518 14.836 49.8518 13.6464 49.8518 13.6464H45.5798V28.818H49.9917C49.9917 28.818 49.9917 24.6569 49.9917 24.4285C50.8302 25.2801 52.3133 25.6822 54.6528 25.6822C58.7658 25.6822 61.7509 23.1117 61.7509 19.5728C61.7509 15.7218 58.9237 13.3291 54.375 13.3291ZM53.5154 22.8368C51.6921 22.8368 49.8518 21.8466 49.8518 19.6379C49.8518 17.4282 51.6921 16.4391 53.5154 16.4391C55.3524 16.4391 57.2043 17.4282 57.2043 19.6379C57.2043 21.8466 55.3524 22.8368 53.5154 22.8368Z"
      fill="#1B1C20"
    />
    <path
      d="M88.1469 13.2382C84.6148 13.2382 81.2651 13.7136 80.6704 17.1595L80.6598 17.2194H84.9784L84.9933 17.1884C85.5297 15.9388 86.3088 15.8076 87.9603 15.8076C90.6285 15.8076 90.9974 16.3967 90.9974 17.0323C90.9974 17.8013 90.743 17.9729 89.4804 18.0576L85.1417 18.3326C83.4223 18.4369 79.8489 18.655 79.8489 21.8849C79.8489 24.1194 82.182 25.678 85.5244 25.678C86.9618 25.678 89.5843 25.4827 91.1892 24.2218C91.1924 24.3851 91.2126 25.3494 91.2126 25.3494H95.4125L95.4135 17.3352C95.4135 14.5022 93.1705 13.2382 88.1469 13.2382ZM91.1362 20.6808C91.1362 22.4482 89.0246 23.3732 86.9395 23.3732C85.4533 23.3732 84.5279 22.8172 84.5279 21.9242C84.5279 21.0539 85.0728 20.6911 86.5335 20.5816C86.5346 20.5816 88.9038 20.3904 88.9038 20.3904C89.596 20.3335 90.3931 20.2477 91.1362 19.9645C91.1362 20.0834 91.1362 20.6808 91.1362 20.6808Z"
      fill="#1B1C20"
    />
    <path
      d="M43.8762 19.9966C43.8762 15.7642 40.8339 13.2382 35.7393 13.2382C30.6542 13.2382 27.3691 15.6277 27.3691 19.3258C27.3691 23.4228 30.3415 25.678 35.7393 25.678C39.7431 25.678 42.372 24.3964 43.555 21.8684L43.6589 21.6451H38.9247L38.8759 21.7164C38.2919 22.5577 37.2371 22.9836 35.7393 22.9836C33.0817 22.9836 32.0037 21.4849 31.9295 20.502C32.0439 20.502 43.8762 20.502 43.8762 20.502V19.9966ZM31.8012 18.3026C31.8107 17.9532 32.539 15.8272 35.646 15.8272C38.5325 15.8272 39.4367 17.6328 39.4441 18.3026C39.3392 18.3026 31.9061 18.3026 31.8012 18.3026Z"
      fill="#1B1C20"
    />
    <path
      d="M104.976 14.6025C108.742 9.87603 113.087 5.61157 117.91 1.91248H104.976V14.6025Z"
      fill="#FDCA00"
    />
    <path
      d="M104.976 14.6025V29.6325C111.243 17.821 121.113 8.12001 133.159 1.91248H117.91C113.087 5.61157 108.742 9.87603 104.976 14.6025Z"
      fill="#EE7900"
    />
    <path
      d="M104.976 29.6324V37.0875H110.581C116.447 23.7422 127.391 13.0232 141.039 7.23735V1.91248H133.159C121.113 8.12001 111.243 17.821 104.976 29.6324Z"
      fill="#D8000B"
    />
    <path
      d="M110.581 37.0874H119.802C124.516 28.1978 131.955 20.904 141.039 16.253V7.2373C127.391 13.0232 116.447 23.7422 110.581 37.0874Z"
      fill="#2E1C85"
    />
    <path
      d="M119.802 37.0875H129.457C132.511 32.5905 136.45 28.7157 141.039 25.708V16.2531C131.955 20.9041 124.516 28.1979 119.802 37.0875Z"
      fill="#0076C0"
    />
    <path
      d="M129.457 37.0875H141.039V25.708C136.45 28.7157 132.511 32.5905 129.457 37.0875Z"
      fill="#009836"
    />
  </svg>
)

Mepha.propsTypes = {
  fillColor: PropTypes.string,
}

Mepha.defaultProps = {
  fillColor: "currentColor",
}

export { Mepha }
